import { createStyles, darken, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    companyIcon: {
      marginRight: 12,
      fontSize: 26,
    },
    refreshButton: {
      marginRight: -theme.spacing(1),
      color: theme.palette.error.main,
      '&:hover': {
        color: darken(theme.palette.error.main, 0.1),
      },
    },
  });

export default styles;
